<script type="text/javascript">
import { h, Transition, Comment, Text, Fragment } from 'vue'
import {
  EventBus
} from '@/utils/event-bus'
import { getCheckoutAppShell } from '@/utils/checkout-app-shell'

// Vue 3 <Transition> picks the FIRST non-Comment slot child as the element to
// animate (in production builds it `break`s on the first match — see
// BaseTransition.render in runtime-core). Because cb-checkout sets
// `whitespace: 'preserve'` globally (Fix 21, needed for payment-summary
// spacing), every newline between consumer's <cb-toggle> opening tag and the
// first real element becomes a Text VNode and steals the transition slot,
// dropping the actual element from the DOM (PortalLogin's cb-auth__slide
// rendered as a bare " "). Filter to a single element child before handing
// it to <Transition> so the real element always wins.
function pickElementChild(nodes) {
  if (!nodes) { return null; }
  for (const node of nodes) {
    if (!node) { continue; }
    if (node.type === Comment || node.type === Text) { continue; }
    if (node.type === Fragment) {
      const found = pickElementChild(Array.isArray(node.children) ? node.children : []);
      if (found) { return found; }
      continue;
    }
    return node;
  }
  return null;
}

export default {
  props: ["parent", 'reCalculateMargin'],
  computed: {
    app () {
      return getCheckoutAppShell()
    }
  },
  methods: {
    enter(el) {
      if(!this.parent){
        return;
      }
      this.parent.style['opacity'] = '0';
      el.style.opacity = '0';
      window.cbTimeout(() => {
        this.parent.style['height'] = el.clientHeight + 'px';
        this.resetElement(el);
      }, 100);
    },
    calculateAppMargin(){
      if (!this.app) return;
      let isPreview = window && window.initInfo && window.initInfo.is_preview;
      let minMarginTop = (isPreview) ? 90 : 20;
      if ((window.innerHeight - this.app.clientHeight) > minMarginTop) {
        let diff = window.innerHeight - this.app.clientHeight;
        this.app.style.marginTop = (diff / 2.0) + "px";
      } else {
        this.app.style.marginTop = minMarginTop + "px";
      }
    },
    resetElement(el){
      window.cbTimeout(() => {
        this.parent.style['opacity'] = '1';
        el.style.opacity = '1';
        this.parent.style['height'] = 'auto';
        EventBus.setPrevHeight();
        this.reCalculateMargin && !window.isMobile && this.calculateAppMargin();
        this.$emit('toggled');
      },500);
    },
    beforeLeave(el) {
      if(!this.parent){
        return;
      }
      this.parent.style['height'] = el.clientHeight + 'px';
      this.parent.style['opacity'] = '0';
    },
  },
  render() {
    const slotChildren = this.$slots.default
      ? (typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default)
      : [];
    const elementChild = pickElementChild(slotChildren);
    return h(
      Transition,
      {
        mode: 'out-in',
        onEnter: this.enter,
        onBeforeLeave: this.beforeLeave,
      },
      { default: () => (elementChild ? [elementChild] : []) }
    );
  },
}
</script>
